import { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import AddSubCategory from "./AddSubCategory";
import UpdateSubCategory from "./UpdateSubCategory";
import {
  useGetSubCategoryQuery,
  useRemoveSubCategoryMutation,
} from "../../../features/api/subcategoryApi";
import { toast } from "react-toastify";

const SubCategory = () => {
  const { data, isLoading } = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const subCategories = data?.brandData;
  console.log(subCategories)

  const [removeSubCategory] = useRemoveSubCategoryMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeSubCategory(id);

        if (result) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Search Term Start
  const [searchTerm, setInputValue] = useState("");
  const searchResults = subCategories?.filter((option) => {
    if (option && typeof option === "object") {
      return Object.values(option).some((value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(searchTerm.toLowerCase());
        } else {
          return String(value).toLowerCase().includes(searchTerm.toLowerCase());
        }
      });
    } else {
      return false;
    }
  });
  // Search Term End

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-6">
        <h1 className="text-xl font-bold">Brand Management</h1>
        <AddSubCategory />
      </div>
      <input
        type="text"
        placeholder="Search Brand"
        className="border border-slate-400 focus:outline-none h-10 w-[250px] mb-3 rounded p-1 bg-white"
        value={searchTerm}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <div className="">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : subCategories?.length === 0 ? (
          <p className=" text-xl text-red-500">There are no Brand</p>
        ) : (
          <TableContainer
            component={Paper}
            // style={{ backgroundColor: "#f0f0f5" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Brand Name</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchResults
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    return (
                      <TableRow key={row.id}>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{row?.sub_catName}</TableCell>
                        <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            <UpdateSubCategory subCategory={row} />
                            <span onClick={() => handleDelete(row?.id)}>
                              <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={subCategories?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default SubCategory;
